import * as yup from 'yup';

export const createWorkspaceSchema = (t: (key: string) => string) =>
  yup.object({
    newWorkspaceName: yup
      .string()
      .required(t('workspace.nameRequired'))
      .min(2, t('workspace.nameInvalid')),
    description: yup
      .string()
      .required(t('workspace.descriptionRequired'))
      .min(2, t('workspace.descriptionInvalid')),
  });
